import { FC, memo } from "react"
import { CurrencyDto, CurrencyType } from "."
import { IOption } from "../../../types"
import { Timer } from "../../common/Timer"
import { CryptoItem } from "../CryptoItem"
import { FiatItem } from "../FiatItem"
import { FlatExchangeSelect } from "../FlatExchangeSelect"
import { SelectorButton } from "../SelectorButton"

type Props = {
  isMobile: boolean
  cryptoOptions: CurrencyType[]
  cryptoCurrency: CurrencyDto | null | undefined
  cryptoAmount: string
  onCryptoAmountChange: (amount: string) => void
  onCryptoCurrencyChange: (option: CurrencyDto) => void
  fiatOptions: CurrencyType[]
  fiatCurrency: CurrencyDto | null | undefined
  fiatAmount: string
  onUpdate: () => void
  onFiatAmountChange: (amount: string) => void
  onFiatCurrencyChange: (option: CurrencyDto) => void
  onBuyClick: () => void
}

const BuyBlockComponent: FC<Props> = ({
  cryptoOptions,
  isMobile,
  cryptoCurrency,
  cryptoAmount,
  onCryptoAmountChange,
  onCryptoCurrencyChange,
  fiatOptions,
  fiatCurrency,
  fiatAmount,
  onUpdate,
  onBuyClick,
  onFiatAmountChange,
  onFiatCurrencyChange,
}) => {
  return (
    <div style={{ display: "flex", flexDirection: "column", gap: isMobile ? "40px" : "80px" }}>
      <div
        style={{
          display: "flex",
          gap: "20px",
          flexDirection: "column",
        }}
      >
        <FlatExchangeSelect
          label={!isMobile ? "You Spend" : undefined}
          buttonTitle={() => <SelectorButton isOpen={true} code={fiatCurrency?.code ?? ""} name={fiatCurrency?.name ?? ""} />}
          inputValue={fiatAmount}
          onChangeInput={(x) => onFiatAmountChange(x.target.value)}
          // @ts-ignore
          onChange={(x) => onFiatCurrencyChange(x.meta)}
          dropDownStyle={{ overflowY: "auto" }}
          options={fiatOptions}
          renderOption={(option: IOption<string, { name: string; rate: number }>, optionProps) => (
            <FiatItem
              {...optionProps}
              isActive={option.value === fiatCurrency?.code}
              key={option.value}
              name={option.label}
              currency={option.label}
            />
          )}
        />
        <FlatExchangeSelect
          label={!isMobile ? "You Receive" : undefined}
          buttonTitle={() => <SelectorButton isOpen={true} code={cryptoCurrency?.code ?? ""} name={cryptoCurrency?.name ?? ""} />}
          inputValue={cryptoAmount}
          onChangeInput={(x) => onCryptoAmountChange(x.target.value)}
          // @ts-ignore
          onChange={(x) => onCryptoCurrencyChange(x.meta)}
          options={cryptoOptions}
          dropDownStyle={{ overflowY: "auto" }}
          renderOption={(option: IOption<string, { name: string; rate: number }>, optionProps) => (
            <CryptoItem
              {...optionProps}
              key={option.value}
              isActive={option.value === cryptoCurrency?.code}
              name={option.label}
              currency={option.value}
            />
          )}
        />
      </div>

      <div
        style={{
          display: "flex",
          flexDirection: isMobile ? "column" : "row",
          gap: "16px",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <button
          style={{
            border: "none",
            outline: "none",
            color: "#ffffff",
            height: "65px",
            borderRadius: "60px",
            padding: "0 34px",
            backgroundColor: "#E41E1F",
          }}
          onClick={onBuyClick}
        >
          Buy {cryptoCurrency?.code ?? ""}
        </button>

        <Timer
          style={{
            lineHeight: "165%",
            fontSize: "16px",
            fontWeight: 500,
            letterSpacing: "-0.16px",
            opacity: 1,
            color: "#818181",
          }}
          withIcon={false}
          count_down={60}
          onUpdate={onUpdate}
          text={"Recalculated in"}
          className={"exchange-form__text_time"}
        />
      </div>
    </div>
  )
}

export const BuyBlock = memo(BuyBlockComponent)
